var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsLightShieldOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.7215C7.493 15.274 6.24125 14.3612 5.24475 12.9832C4.24825 11.6052 3.75 10.0525 3.75 8.32499V4.26899L9 2.30774L14.25 4.26899V8.32499C14.25 10.052 13.7517 11.6045 12.7552 12.9825C11.7587 14.3605 10.507 15.273 9 15.7215ZM9 14.9257C10.3 14.5132 11.375 13.6882 12.225 12.4507C13.075 11.2132 13.5 9.83824 13.5 8.32574V4.78124L9 3.10874L4.5 4.78124V8.32499C4.5 9.83749 4.925 11.2125 5.775 12.45C6.625 13.6875 7.7 14.5132 9 14.9257Z",
    fill: "#271E4A",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsLightShieldOutline);
export default __webpack_public_path__ + "static/media/material-symbols-light_shield-outline.2f32628a96007da0895ad28b75bc73b7.svg";
export { ForwardRef as ReactComponent };